module.exports = __webpack_public_path__ + "img/header-hand@2x.2c703164.png";